import { TEXT_COLORS as TC } from '@constants/colors.ts';
import { DESKTOP_SIZES, FONT_FAMILY, SIZES } from '@constants/fonts.ts';
import styled from 'styled-components';

export const Name = styled.div`
    ${FONT_FAMILY.poppins};
    color: ${TC.heading};
    ${DESKTOP_SIZES[SIZES.BODY_SM].fontSize}
    ${DESKTOP_SIZES[SIZES.BODY_SM].lineHeight}
    ${DESKTOP_SIZES[SIZES.HEADING_XXL].fontWeight};
`;

export const Role = styled.div`
    ${FONT_FAMILY.poppins};
    color: ${TC.body};
    ${DESKTOP_SIZES[SIZES.BODY_XS].fontSize}
    ${DESKTOP_SIZES[SIZES.BODY_XS].lineHeight}
    ${DESKTOP_SIZES[SIZES.BODY_SM_MED].fontWeight};
`;
